import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import ArrowWithoutTail from '@/assets/ArrowWithoutTail';

type TenureSelectorDropdownProps = {
	currentTenure: number;
	openTenureSelector: () => void;
	labels?: any;
};

const TenureSelectorDropdown = (props: TenureSelectorDropdownProps) => {
	function tenureSelectorDropdownClicked(e: any) {
		e.stopPropagation();
		props.openTenureSelector();
	}

	return (
		<Box
			sx={{
				border: `1px solid ${getColor('Minty 0')}`,
				height: '30px',
				borderRadius: '24px',
				// boxShadow: '-1px 11px 11px -8px rgb(6 155 170 / 66%)',
			}}
			onClick={tenureSelectorDropdownClicked}
			className='cursor-pointer'
		>
			<FlexBox
				sx={{
					padding: '5px 16px',
					justifyContent: 'space-evenly',
					alignItems: 'center',
				}}
			>
				<LencoTypography
					sx={{
						...getStyle('Small_SemiBold'),
						color: getColor('Minty 0'),
					}}
				>
					{/* {props.currentTenure} {props.currentTenure > 1?'months':'month'} */}
					{props?.labels && props?.labels[props.currentTenure]}
				</LencoTypography>
				<Box ml='4px'>
					<ArrowWithoutTail
						color={getColor('Minty 0')}
						height={10}
						width={12}
					/>
				</Box>
			</FlexBox>
		</Box>
	);
};

export default TenureSelectorDropdown;
